import { Component, Input } from '@angular/core';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';

@Component({
  standalone: false,
  selector: 'webform-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent {
  @Input() title!: string;
  @Input() url!: string;

  get icon(): mobiIcon {
    const pdfRegex = /\.pdf$/i;

    if (pdfRegex.test(this.url)) {
      return 'document';
    } else {
      return 'paper_plane';
    }
  }
}
